import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';

export default function SolvateLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Solvate Library');
  }, []);
  return <div>Solvate Library</div>;
}
